import React, { Fragment } from "react";
import {
    Row,
    Select,
    Checkbox,
    Table,
    Button,
    Col,
    DatePicker,
    message,
    Breadcrumb,
    Divider,
    Radio,
    Upload,
    Input,
    Modal
} from "antd";
import $ from 'jquery'
import "./upload.css"
import { connect } from 'react-redux';
import axios from "axios";
import moment from 'moment'
import * as dateTimeTools from './dateTimeTools'
import Footer from '../../Footer/index'
import BGimage from '../resources/query_top_alpha_bg.png'
import SXimg from '../resources/advanced_query.png'
import Axios from "axios";
import Header4 from "../../Header/Header4";
import Navigator from '../../Navigator'
import DownFileComponent from './downFileComponent'
import FileViewer from 'react-file-viewer'
import PDFViewer from 'react-pdf-js'
import Base64 from "base-64"
import fileCart from '../../../resources/img/icon-fileCart.png'

const { Search } = Input
const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD"
const getScoreRoot = global.url ? global.url.score : null;

// import Base64 from "base-64";

class FileDownload extends React.Component {
    state = {
        data: [],//文档列表
        dataTotal: 0,//文档数量
        currentPage: 1,//当前所处页面

        searchValue: "",//当前输入的检索词
        timeMode: "",//当前选择的时间范围按钮
        startTime: -1,//上传时间范围————开始时间
        endTime: -1,//上传时间范围————结束时间
        // plainOptions: ['Word文档', 'PDF', 'Excel', 'caj', 'PPT'],//默认文件类型列表
        // plainOptions: ['新闻信息类', '标准规范类', '政策法规类', '技术原理及应用说明类','社会经济类','人口数据','其他'],//默认文件类型列表
        // checkedOptions: [0, 1, 2, 3, 4],//当前选中的文件类型列表
        orderList: [],//下载列表，列表暂且为批量下载预留
        userScore: 0,//当前用户拥有积分
        totalScore: 0,//所有下载积分

        nowClickFile: undefined,//当前点击的文件
        preLookModalFlag: false,

        filePreviewPath: '',//文档预览路径

        pdfPage: 1,//PDF预览时当前页面数
        pdfTotalPages: 0,//PDF总页数

        selectedValue: '全部',//记录选择框中的值，默认选择全部
        documentTypeScore: 0,//记录文档类型数据的下载分数
        CartModal: false,
        cartData: [],
        selectedRows: [],
        selectedRowKeys: [],
        cartDataNum: 0

    }

    async componentDidMount() {
        await this.getUserScore();
        await this.getProdDocuments(this.state.searchValue, -1, -1, 1, this.state.selectedValue)
        await this.getDiffTypeDataScore()
        await this.getCartData()
    }

    componentDidUpdate(prevProps, prevState) {
        console.log(this.props.zd_user, prevProps.zd_user)
        if (this.props.zd_user.userId !== prevProps.zd_user.userId) {

            this.getProdDocuments(this.state.searchValue, -1, -1, 1, this.state.selectedValue)
        }

        if (this.props.user.name !== prevProps.user.name) {
            this.getUserScore()
        }
    }

    //获取文档类型的下载所需分数

    getDiffTypeDataScore = async () => {
        const { data: res } = await axios.get(getScoreRoot + '/type/list')
        // console.log(res)
        if (res.code === '200') {
            res.payload.map(element => {
                if (element.resourceType === '文档数据') {
                    this.setState({
                        documentTypeScore: element.downloadScore
                    })
                    return
                }
            })
        } else {
            message.error('文档类型数据下载积分获取失败!')
        }
    }

    getProdDocuments = async (searchValue, startTime, endTime, currentPage, selectedValue) => {
        if (!this.props.zd_user.token)
            return
        if (selectedValue === '全部') {
            const { data: docRes } = await axios.get(`/dataBaseDocQueryUrl/api/getProdDocuments?multikeyword=${searchValue}&endtime=${endTime}&num=10&page=${currentPage}&starttime=${startTime}`, {
                headers: {
                    Authorization: this.props.zd_user.token
                }
            })
            if (docRes.code !== '0') {
                message.error('文档列表获取失败!')
            } else {
                //   console.log(docRes)
                this.setState({
                    data: docRes.data.list,
                    currentPage: currentPage,
                    dataTotal: docRes.data.total
                })
            }
        } else {
            const { data: docRes } = await axios.get(`/dataBaseDocQueryUrl/api/getProdDocuments?multikeyword=${searchValue}&endtime=${endTime}&num=10&page=${currentPage}&starttime=${startTime}&doctype=${selectedValue}`, {
                headers: {
                    Authorization: this.props.zd_user.token
                }
            })
            if (docRes.code !== '0') {
                message.error('文档列表获取失败!')
            } else {
                //   console.log(docRes)
                this.setState({
                    data: docRes.data.list,
                    currentPage: currentPage,
                    dataTotal: docRes.data.total
                })
            }
        }

    }

    getCartData = async () => {
        try {
            let { data } = await axios.get(`${window.url.order}/shop/listfileshop?userId=${this.props.user.userId}`)
            console.log('zzz', data)
            if (data.code === '200') {
                this.setState({
                    cartData: data.payload,
                })
            } else {
                throw ('查询失败')
            }
        } catch (error) {
            message.error('查询失败')
        }

    }


    timeTransform = (time) => {
        var year = new Date(time).getFullYear()
        var month = new Date(time).getMonth() + 1
        var date = new Date(time).getDate()
        var hours = new Date(time).getHours()
        var minutes = new Date(time).getMinutes()
        var seconds = new Date(time).getSeconds()

        var result = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds

        return result
    }

    /**
     * 用于在文件预览时返回预览链接，处理资源链接的函数
     * @param resourceUrl {string}
     * @returns {*|string}
     */
    getPreViewUrl = (resourceUrl) => {
        // console.log('预览文件路径：', resourceUrl);
        // let region = /caplos.aircas.ac.cn\/\/?oss/;
        // let newResource = '';
        // let fileType = resourceUrl.split('.').splice(-1)[0];
        // let imageType = ['png', 'jpg', 'jpeg'];
        // // kkFile组件预览图片时需要外网的地址，预览文件时需要内网的地址
        // if (imageType.includes(fileType)) {
        //     newResource = resourceUrl;
        // } else {
        //     newResource = resourceUrl.replace(region, global.filePrevUrl);
        // }
        console.log('文件原路径：', resourceUrl);
        console.log('文件预览接口路径：', `${global.support.filePreview}/onlinePreview?url=${btoa(unescape(encodeURIComponent(resourceUrl)))}`)
        return `${global.support.filePreview}/onlinePreview?url=${btoa(unescape(encodeURIComponent(resourceUrl)))}`;
        //
    }


    getPreviewPath = async (file) => {
        let dataName = file.title
        const { data: res } = await axios.get(`/dataBaseDocQueryUrl/api/getDocumentPath?dataNames=${dataName}&dataType=document`, {
            headers: {
                Authorization: this.props.zd_user.token
            }
        })
        if (res.code !== '0') {
            message.error('文档预览失败！')
        } else {
            // console.log(dataName)
            // console.log(res.data)
            console.log(Object.values(res.data)[0])
            // console.log(res.data.dataName)
            console.log('文件路径：', Object.values(res.data)[0])
            // let newUrl = Object.values(res.data)[0].replace("http://10.0.121.14:8084", "http://caplos.aircas.ac.cn/zdTiles")
            let newUrl = Object.values(res.data)[0];
            console.log('newUrl', newUrl)


            this.setState({
                filePreviewPath: newUrl
            }, () => {
                this.setState({ preLookModalFlag: true, })
            })
            // return res.data.dataName
        }
    }

    onDocumentComplete = (pages) => {
        this.setState({
            pdfPage: 1,
            pdfTotalPages: pages
        })
    }

    handlePrivious = () => {
        this.setState({
            pdfPage: this.state.pdfPage - 1

        })
    }

    handleNext = () => {
        this.setState({
            pdfPage: this.state.pdfPage + 1

        })
    }

    handleChangeDocType = (value) => {
        const { searchValue, startTime, endTime, currentPage, selectedValue } = this.state
        console.log("docType", value)
        this.setState({
            selectedValue: value
        }, () => {
            // this.getProdDocuments(searchValue,startTime,endTime,1,selectedValue)
            // this.searchFiles(this.state.searchValue,this.state.startTime,this.state.endTime,this.state.selectedValue)
        })
        this.getProdDocuments(searchValue, startTime, endTime, 1, value)
    }

    changePage = (pageNum) => {
        console.log(pageNum)
        const { searchValue, startTime, endTime, currentPage, selectedValue } = this.state
        this.getProdDocuments(searchValue, startTime, endTime, pageNum, selectedValue)
    }

    addCart = async (fileData) => {
        let { data } = await axios.post(`${window.url.order}/shop/save`, [{
            "fileName": fileData.title,
            "fileSize": fileData.sizek,
            "resourceType": "文档数据",
            "score": fileData.score,
            "userId": this.props.user.userId
        }])
        if (data.code === '200')
            message.success('添加购物车成功')
        else
            message.error('添加购物车失败')
    }

    openCartModal = () => {
        this.getCartData()
        this.setState({
            CartModal: true
        })
    }

    render() {

        // const plainOptions = ['Word文档', 'PDF', 'Excel', 'caj', 'PPT'];
        const columns = [
            {
                title: '文件名',
                dataIndex: 'title',
                width: "30vw",
                render: (text, file) => {
                    return <a className="media" rel='noopener noreferrer'
                        onClick={() => this.openPreLook(text, file)}
                        title={text}
                    >
                        {this.returnLessName(text)}
                    </a>
                }
            },
            {
                title: '文档大小',
                dataIndex: 'sizek',
                render: size => <Col
                    style={{ textAlign: 'center' }}>{size < 1024 ? size + 'KB' : size < 1024 * 1024 ? ((size / 1024).toFixed(2) + 'MB') : size < 1024 * 1024 * 1024 ? ((size / 1024 / 1024).toFixed(2) + 'GB') : ((size / 1024 / 1024 / 1024).toFixed(2) + 'TB')} </Col>
            },
            {
                title: '上传时间',
                dataIndex: 'importtime',
                render: (_, data) => (
                    <div style={{ textAlign: 'center' }}>{this.timeTransform(data.importtime)}</div>
                ),
            }, {
                title: '文档类型',
                dataIndex: 'doctype',
            }, {
                title: '价格',
                dataIndex: 'score',
                render: (_, data) => (
                    <div style={{ textAlign: 'center' }}>{`${this.state.documentTypeScore}积分`}</div>
                ),
            }, {
                title: '操作',
                dataIndex: 'operation',
                render: (_, data) => (
                    <>
                        <a style={{ textAlign: 'center' }} onClick={() => this.downLoadFile(data)}>
                            下载
                        </a>
                        <a style={{ textAlign: 'center', marginLeft: '10px' }} onClick={() => this.addCart(data)}>
                            加购物车
                        </a>
                    </>
                ),
                width: 140
            },
        ];
        const columnsCart = [
            {
                title: '文件名',
                dataIndex: 'fileName',
                key: 'fileName'
            },
            {
                title: '文档大小',
                dataIndex: 'fileSize',
                key: 'fileSize',
                render: (_, data) => (
                    <div>
                        {data.fileSize}KB
                    </div>
                )
            }, {
                title: '文档类型',
                dataIndex: 'resourceType',
                key: 'resourceType'
            }, {
                title: '操作',
                dataIndex: 'operation',
                render: (_, data) => (
                    <>
                        <a style={{ textAlign: 'center' }} onClick={() => this.downLoadFile(data)}>
                            下载
                        </a>
                        <a style={{ textAlign: 'center', 'marginLeft': '10px' }} onClick={() => this.deleteFile(data)}>
                            删除
                        </a>
                    </>
                ),
            },
        ];
        // '新闻信息类', '标准规范类', '政策法规类', '技术原理及应用说明类', '社会经济类','人口数据','其他'
        const selectOptions = [{
            value: '全部',
            lable: '全部'
        }, {
            value: '新闻信息类产品数据',
            lable: '新闻信息类产品数据'
        }, {
            value: '标准规范类产品数据',
            label: '标准规范类产品数据'
        }, {
            value: '产品质量检验成果',
            label: '产品质量检验成果'
        }, {
            value: '流程模块检验成果',
            label: '流程模块检验成果'
        }, {
            value: '政策法规类产品数据',
            label: '政策法规类产品数据'
        }, {
            value: '技术原理及应用说明类产品数据',
            label: '技术原理及应用说明类产品数据'
        }, {
            value: '社会经济数据',
            label: '社会经济数据'
        }, {
            value: '人口数据',
            label: '人口数据'
        }, {
            value: '其它数据',
            label: '其它数据'
        }]
        const {
            searchValue, timeMode, plainOptions, preLookModalFlag, nowClickFile,
            orderList, userScore, totalScore, showDownLoadModalFlag, filePreviewPath, pdfPage, pdfTotalPages,
            dataTotal, CartModal, cartData, selectedRowKeys
        } = this.state;
        // console.log('文件预览链接：',filePreviewPath)
        return (
            <>
                <Header4 />
                <Row gutter={0} style={{ color: 'black' }} className='Upload filedownload'>
                    {/* <Col span={24}>
                <Header /></Col> */}
                    <Col span={24} className='filedownload-search-panel'>
                        <Row gutter={0} style={{
                            color: 'white', background: "url(" + BGimage + ")", backgroundSize: '100%', height: '100%',
                            backgroundRepeat: 'no-repeat'
                        }}>
                            <Col span={3} style={{}} />
                            <Col span={18}>
                                <Row>
                                    <Col span={24} style={{ height: 20 }} />
                                    <Col span={5} />
                                    <Col span={14}>
                                        <Row>
                                            <Col span={24}>
                                                <Search placeholder="搜索文件名、作者、关键字" value={searchValue}
                                                    onChange={(e) => this.setState({ searchValue: e.target.value })}
                                                    onSearch={this.handleSearch} />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={5} />
                                    <Col span={24} style={{ height: 20 }} />
                                    <Col span={5} />
                                    <Col span={14}>
                                        <Row>
                                            <Col span={4} style={{ color: '#ffffff99' }}
                                                className='download-textblock'> 上传时间 </Col>
                                            <Col span={20}>
                                                <Radio.Group className="Filedownload_Radio" defaultValue={""}
                                                    onChange={this.onChangeTimeMode}>
                                                    <Radio style={{ color: 'white' }} value={""}>所有时间</Radio>
                                                    <Radio style={{ color: 'white' }} value={"oneMonth"}>近一个月</Radio>
                                                    <Radio style={{ color: 'white' }} value={"halfYear"}>近半年</Radio>
                                                    <Radio style={{ color: 'white' }} value={"oneYear"}>近一年</Radio>
                                                    <Radio style={{ color: 'white' }}
                                                        value={"defined"}>选择其他时间</Radio>
                                                    {timeMode === "defined" ?
                                                        <div className='Filedownload_TimeRange'>
                                                            <RangePicker
                                                                defaultValue={[moment(), moment()]}
                                                                format={dateFormat}
                                                                onChange={(mom, value) => this.dateOnChange(mom, value)}
                                                            />
                                                        </div>
                                                        : null}
                                                </Radio.Group>
                                            </Col>
                                            <Divider className='whitedivider' style={{ marginTop: 8, marginBottom: 8 }} />
                                            <Col span={4} style={{ color: '#ffffff99' }}
                                                className='download-textblock'>文档类型</Col>
                                            <Col span={20}>
                                                {/* <Checkbox.Group className='checkboxwhite' options={plainOptions}  onChange={this.typeOnChange} /> */}
                                                <Select className="docType-select"
                                                    defaultValue="全选"
                                                    // style={{
                                                    //     width: 120,
                                                    // }}
                                                    onChange={(e) => this.handleChangeDocType(e)}
                                                    options={selectOptions}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={5} />
                                    <Col span={24} style={{ height: 20 }} />
                                </Row>
                            </Col>
                            <Col span={3} style={{}} />
                            <Col span={24} style={{ height: 50 }} />
                        </Row>
                    </Col>
                    {/* <Col span={24} className='filedownload-table-panel' ></Col> */}
                    <Col span={24} className='filedownload-table-panel'>
                        <Row gutter={0} style={{ marginTop: -47 }}>
                            <Col span={3} style={{}}></Col>
                            <Col span={18}>
                                <Table size="middle"
                                    pagination={{
                                        // pageSize: 10,
                                        // showSizeChanger: false
                                        total: dataTotal,
                                        onChange: (e) => this.changePage(e)
                                    }}
                                    // showQuickJumper 
                                    className='filelist1'
                                    columns={columns}
                                    dataSource={this.state.data}
                                />
                            </Col>
                            <Col span={3} style={{}} />
                        </Row>
                    </Col>
                </Row>
                {/* <Navigator /> */}
                <Modal className="Filedownload_Modal" visible={preLookModalFlag} footer={null} title={"预览"}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ preLookModalFlag: false })}>
                    {nowClickFile ?
                        <Fragment>
                            <div className='Filedownload_Modal_Title'>
                                <div className='Filedownload_Modal_TitleText'>{nowClickFile.fileName}</div>
                            </div>
                            {/* <div className='Filedownload_Modal_Content'>
                                <iframe id="Filedownload_Modal_Iframe" className='Filedownload_Modal_Iframe'
                                    src={this.returnUrl(nowClickFile.url)} onLoad={this.iframeOnload}
                                    
                                />  
                            </div> */}
                            {
                                filePreviewPath === '' ?
                                    <div className="Filedownload_Modal_Empty">暂无内容</div> :
                                    <div className='Filedownload_Modal_Content'>
                                        <iframe id="Filedownload_Modal_Iframe" className='Filedownload_Modal_Iframe'
                                            src={this.getPreViewUrl(filePreviewPath)} />
                                    </div>
                            }

                        </Fragment>
                        : <div className="Filedownload_Modal_Empty">暂无内容</div>}
                </Modal>
                <Modal
                    className="Cart_Modal"
                    title="购物车"
                    visible={CartModal}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ selectedRowKeys: [], CartModal: false })}
                    footer={[<Button type='primary' onClick={() => this.downLoadFile()}>全部下载</Button>]}
                    width={'55vw'}
                >
                    <div>
                        <Table
                            rowSelection={{
                                selectedRowKeys: this.state.selectedRowKeys,
                                onChange: (selectedRowKeys, selectedRows) => {
                                    // let keylist = selectedRowKeys.split(',')
                                    let keyList = this.state.selectedRowKeys
                                    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                                    this.setState({
                                        selectedRows: selectedRows,
                                        selectedRowKeys: selectedRowKeys
                                    })
                                },
                            }}
                            columns={columnsCart}
                            dataSource={cartData}
                            rowKey={'shopId'}
                            size='small'
                            pagination={{
                                // onChange: (page, pageSize) => {
                                //     this.getCartData(page)
                                // }
                            }}
                        />
                    </div>
                </Modal >
                <DownFileComponent orderList={orderList} userScore={userScore} totalScore={totalScore}
                    showDownLoadModalFlag={showDownLoadModalFlag}
                    closeDownLoadModal={this.closeDownLoadModal}
                    orderKeyList={selectedRowKeys}
                />
                {/* <div className="floatButton">
                    <img className='floatButton-icon' src={fileCart} onClick={this.openCartModal}></img>
                </div> */}
            </>
        )
    }

    /*检索*/
    // serchFirst = () => {
    //     const { searchValue, startTime, endTime, checkedOptions } = this.state;
    //     this.searchShareFile(1, 10, searchValue, startTime, endTime, checkedOptions, 0);
    // }
    // serchData = (value) => {
    //     const { startTime, endTime, checkedOptions } = this.state;
    //     this.searchShareFile(1, 10, value, startTime, endTime, checkedOptions, 0);
    // }
    // searchShareFile = (page, limitCount, keyWord, startTime, endTime, checkedOptions, sort) => {
    //     let startTime1 = startTime && startTime.replace("T"," ");
    //     let endTime1 = endTime && endTime.replace("T"," ");
    //     let query = dateTimeTools.returnQueryBySearchShareFile(page, limitCount, keyWord, startTime1, endTime1, checkedOptions, sort);
    //     axios.get(global.url.getFileShare + `/document/getdocument${query}`
    //     ).then(res => {
    //         console.log("serchData-----", res.data);
    //         if (res.data.code === "200") {
    //             let data = res.data.payload.records;
    //             this.setState({ data: [...data] });
    //         }
    //         else {
    //             message.error("检索失败，请检查网络连接……")
    //         }
    //     }).catch((e) => {
    //         message.error("检索失败，请检查网络连接……")
    //         console.log(e);
    //     })
    // }
    /*---------------- */

    handleSearch = () => {
        const { searchValue, startTime, endTime, currentPage, selectedValue } = this.state
        this.getProdDocuments(searchValue, startTime, endTime, 1, selectedValue)
        // this.searchFiles(this.state.searchValue,this.state.startTime,this.state.endTime,this.state.selectedValue)
    }

    //查询功能
    // searchFiles = (searchValue, startTime, endTime, selectedValue) => {
    //     this.getProdDocuments(searchValue, startTime, endTime, selectedValue)

    //     // console.log("searchValue",searchValue,"startTime",startTime,"endTime",endTime,"docType",selectedValue)
    // }

    //下载
    downLoadFile = (data) => {
        console.log("downLoadFile", data);
        if (data) {
            data.score = this.state.documentTypeScore
            this.setState({
                orderList: [data],
                totalScore: data.score,
                showDownLoadModalFlag: true,
            })
        } else {
            console.log(this.state.selectedRows, this.computeScore(this.state.selectedRows))
            this.setState({
                orderList: this.state.selectedRows,
                totalScore: this.computeScore(this.state.selectedRows),
                showDownLoadModalFlag: true,
            })
        }
    }

    deleteFile = async (data) => {
        await axios.delete("/gateway/api/order-service/shop/delete?ids=" + data.shopId).then(res => {
            message.success("删除成功")
            this.getCartData()
        }).catch((e) => {
            message.error("删除失败")
            console.log(e);
        })
    }

    computeScore = (orderList) => {
        let totalScore = 0
        orderList.map(value => {
            totalScore += value.score
        })
        return totalScore
    }

    closeDownLoadModal = () => {
        this.setState({ showDownLoadModalFlag: false });
    }

    /* 更改时间 */
    onChangeTimeMode = (e) => {
        const { searchValue, startTime, endTime, currentPage, selectedValue } = this.state
        let time = dateTimeTools.returnTrainingTimeModeTime(e.target.value);
        console.log("onChangeTimeMode", e.target.value, time);
        if (time !== undefined && (time.startTime !== '' || time.endTime !== '')) {
            let startTime_MS = new Date(time.startTime && time.startTime).getTime() / 1000//将时间转换为秒
            let endTime_MS = new Date(time.endTime && time.endTime).getTime() / 1000//将时间转换为秒
            console.log(startTime_MS)

            console.log(endTime_MS)
            this.setState({
                startTime: startTime_MS,
                endTime: endTime_MS
            }, () => {
                // this.getProdDocuments(searchValue,startTime,endTime,1,selectedValue)
                // this.searchFiles(this.state.searchValue,this.state.startTime,this.state.endTime,this.state.selectedValue)
            })
            this.getProdDocuments(searchValue, startTime_MS, endTime_MS, 1, selectedValue)
        } else {
            this.setState({
                startTime: -1,
                endTime: -1,
            }, () => {
                // this.getProdDocuments(searchValue,startTime,endTime,1,selectedValue)
                // this.searchFiles(this.state.searchValue,this.state.startTime,this.state.endTime,this.state.selectedValue)
            })
            this.getProdDocuments(searchValue, -1, -1, 1, selectedValue)
        }

        // if (time !== undefined) {
        //     this.setState({
        //         startTime: time.startTime,
        //         endTime: time.endTime,
        //     },()=>{
        //         this.serchFirst();
        //     })
        // }
        // else {
        //     this.setState({
        //         startTime: undefined,
        //         endTime: undefined,
        //     },()=>{
        //         this.serchFirst();
        //     })
        // }
        this.setState({
            timeMode: e.target.value,
        })

    }
    dateOnChange = (mom, value) => {
        const { searchValue, startTime, endTime, selectedValue } = this.state
        let startTime1 = new Date(moment(value[0]).format("YYYY-MM-DDTHH:mm:ss")).getTime() / 1000;
        let endTime1 = new Date(moment(value[1]).format("YYYY-MM-DDTHH:mm:ss")).getTime() / 1000;
        // console.log(startTime)
        // console.log(endTime)

        // console.log(startTime.getTime())
        // console.log(endTime.getTime())
        this.setState({
            startTime: startTime1,
            endTime: endTime1,
        }, () => {
            // this.getProdDocuments(searchValue,startTime,endTime,1,selectedValue)
            // this.searchFiles(this.state.searchValue,this.state.startTime,this.state.endTime,this.state.selectedValue)
        })
        this.getProdDocuments(searchValue, startTime1, endTime1, 1, selectedValue)
    }
    /*--------- */
    //检索类型修改
    typeOnChange = (values) => {
        console.log("typeOnChange", values);
        this.setState({ checkedOptions: [...this.returnTypeToNum(values)] }, () => {
            this.serchFirst()
        });
    }

    // '新闻信息类', '标准规范类', '政策法规类', '技术原理及应用说明类', '社会经济类','人口数据','其他'

    returnTypeToNum = (values) => {
        let nums = [];
        values.map((value) => {
            switch (value) {
                case '新闻信息类':
                    nums.push(0);
                    break;
                case '标准规范类':
                    nums.push(1);
                    break;
                case '政策法规类':
                    nums.push(2);
                    break;
                case '技术原理及应用说明类':
                    nums.push(3);
                    break;
                case '社会经济类':
                    nums.push(4);
                    break;
                case '人口数据':
                    nums.push(5);
                    break;
                case '其他':
                    nums.push(6);
                    break;
                default:
                    break;
            }
        });
        return nums;
    }

    //原先希望给后台页面发送更改style以适应界面大小的消息，但是有了分类显示逻辑后，暂无用处
    iframeOnload = () => {
        let iframeDocument = document.getElementById("Filedownload_Modal_Iframe");
        let style = {
            width: "100%",
            height: "100%"
        }
        iframeDocument.contentWindow.postMessage(style, "*");
    }
    //打开预览
    openPreLook = (text, file) => {
        console.log("openPreLook", text, file);
        this.setState({ nowClickFile: file }, () => {
            this.setState({ preLookModalFlag: true, })
        });

        this.getPreviewPath(file)
    }
    //返回预览链接
    // returnUrl = (resourceUrl) => {
    //     if (!resourceUrl)
    //         return;
    //     let typeList = resourceUrl.split(".");
    //     let type = typeList[typeList.length - 1];
    //     console.log();
    //     if (type === "pdf" || type === "mp4" || type === "avi" || type === "mpeg" || type === "wmv" || type === "mov") {
    //         return resourceUrl + "#toolbar=0";
    //     }
    //     else {
    //         return `${previewRoot}/onlinePreview?url=${Base64.encode(resourceUrl)}`;
    //     }
    // }

    getUserScore = async () => {
        axios.get(global.url.score + `/score/getbyid?userId=${this.props.user.userId}`, {
            headers: {
                'Authorization': this.props.user.token
            }
        })
            .then(res => {
                // console.log("getUserScore", res)
                if (res.data.code === '200') {
                    this.setState({ userScore: res.data.payload.score })
                } else {
                    message.error('用户积分查询错误或用户积分不存在');
                }
            }).catch(err => {
                console.log(err);
                // message.error('用户积分查询错误或用户积分不存在');
            })
    }

    returnLessName = (name) => {
        if (name.length > 53) {
            let returnName = name;
            returnName = name.slice(0, 50) + "...";
            return returnName;
        } else
            return name;
    }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props  
    user: state.userReducer.get('user').toJS(),
    zd_user: state.userReducer.get('zd_user').toJS()
})
const mapDispatch = () => ({})

export default connect(mapState, mapDispatch)(FileDownload);
